<template>
  <section class="banner" :id="$t('routes.home')" :ref="$t('routes.home')">
    <div class="sloth-container">
      <div class="banner-content" v-scroll-reveal="{ delay: 120 }">
        <div class="banner-info">
          <h1 class="banner-title">
            SlothTech
          </h1>
          <p class="banner-description">
              {{ $t('main.we_created')}} <span class="text-cta">{{ $t('main.solution')}}</span> <br> {{ $t('main.for_you')}}
          <span><vue-typer :text='services' :shuffle='true'></vue-typer></span>
          </p>
        </div>
        <div class="banner-image" v-scroll-reveal="{ delay: 120 }">
          <img src="/assets/images/banner-splash.png" alt="">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import resources from "./../../i18n/en.json";
const getServicesKeys = obj => {
  return Object.keys(obj).map(k => {
    return `services.${k}`;
  });
};
export default {
  name: "MainBanner",

  props: {
   
  },
  data: () => {
    return {
      keys: [],
      currentService: "",
      services: []
    };
  },
  methods: {},
  created: function() {
    this.keys = getServicesKeys(resources.services);
    this.services = this.keys.map(k => this.$t(k));
    const vm = this;
    this.$root.$on("languageChanged", () => {
      vm.services = vm.keys.map(k => vm.$t(k));
    });
  }
};
</script>